class VerticalMarquee extends HTMLElement { 
    constructor () {
        super();

        this.container = this.querySelector('.marquee__wrap');
        this.array = this.container.querySelectorAll('.marquee-item');
        
        
        this.timeline = this.createTimeLine();
    }

    connectedCallback() {
        this.clone = this.array[0].cloneNode(true);
        this.container.append(this.clone);
        this.array.forEach( (item, i) => {
            this.y = (i + 1) * -100;

            this.timeline.to(this.container, {
                yPercent: this.y
            })
        })
    }


    createTimeLine () {
       return gsap.timeline({
            repeat: -1, 
            defaults: {
                duration: 1.5, 
                delay:1,
                ease: CustomEase.create("custom", "M0,0 C0.871,0.1 0.258,0.961 1,1 "),
            }
        });
    }
}

customElements.define('vertical-marquee', VerticalMarquee);

